<template>
  <el-dialog
    title="Заявки на оценку коллег"
    :visible.sync="show"
    top="2vh"
    :close-on-click-modal="false"
    width="80%"
  >
    <div v-loading="loading">
      <div style="margin-bottom: 25px; display: flex; justify-content: space-between">
        <search-input
          placeholder="Поиск по ФИО"
          style="width: 300px"
          v-model="filters.search"
          @change="filtersChanged"
        >
        </search-input>
        <el-button
          type="primary"
          size="small"
          icon="fas fa-plus"
          @click="openAddDialog"
        >
          Добавить ещё коллег
        </el-button>
      </div>
      <el-table
        :data="evaluators"
        border
        ref="selectEvaluatorsTable"
        :row-key="(row) => row.id"
      >
        <el-table-column type="selection" reserve-selection width="55"></el-table-column>
        <el-table-column width="150" prop="user.persnum" label="Перс. №"></el-table-column>
        <el-table-column prop="user.full_name" label="ФИО"></el-table-column>
        <el-table-column prop="user.email" label="Email"></el-table-column>
        <el-table-column prop="user.position" label="Должность"></el-table-column>
        <el-table-column prop="user.subdivision" label="Подразделение"></el-table-column>
        <el-table-column prop="user.company" label="Компания"></el-table-column>
      </el-table>
      <paginator
        :paginator.sync="paginator"
        use-router-query-param
        @page-changed="loadEvaluators"
      ></paginator>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="show = false">Отмена</el-button>
      <el-button
        :disabled="$refs.selectEvaluatorsTable && !$refs.selectEvaluatorsTable.selection.length"
        :loading="loading"
        type="primary"
        @click="addSelectedRequests(0)"
        size="small"
        icon="fas fa-plus"
      >
        Согласовать отмеченных
      </el-button>
      <el-button
        :loading="loading"
        type="primary"
        @click="addSelectedRequests(1)"
        size="small"
        icon="fas fa-plus"
      >
        Согласовать всех
      </el-button>
      <el-button
        :loading="loading"
        type="primary"
        @click="addSelectedRequests(0, 1)"
        size="small"
        icon="fas fa-plus"
      >
        Отклонить всех
      </el-button>
    </div>

    <add-eval-colleagues-dialog
      ref="addDialog"
      :all="true"
      :user_id="evaluateeId"
      :evaluation="evaluation"
      @load-evaluators="loadEvaluators"
    >
    </add-eval-colleagues-dialog>
  </el-dialog>
</template>

<script>
import {off, on} from "element-ui/src/utils/dom";
import Paginator from "@/components/Paginator";
import {paginator} from "@/mixins/paginator";
import SearchInput from "@/components/filters/SearchInput.vue";
import AddEvalColleaguesDialog from "@/modules/evaluation/components/myEvaluation/AddEvalColleaguesDialog.vue";

export default {
  name: "eval-user-requests-dialog",
  components: {AddEvalColleaguesDialog, SearchInput, Paginator},
  mixins: [paginator],
  beforeMount() {
    this.paginator.perPage = 10;
  },
  data() {
    return {
      loading: false,
      evaluateeId: null,
      evaluationId: null,
      evaluation: {
        type: Object,
        default: {},
      },
      evaluators: [],
      show: false,
      filters: {},
    }
  },
  methods: {
    openAddDialog() {
      this.$refs.addDialog.open();
    },
    getEvaluation() {
      this.$api.evaluation.evaluationGet({
        id: this.evaluationId,
      })
        .then(data => {
          this.evaluation = data.evaluation;
        });
    },
    async open(evaluateeId, evaluationId) {
      this.evaluators = [];
      this.evaluateeId = evaluateeId;
      this.evaluationId = evaluationId;
      this.loadEvaluators();
      this.getEvaluation();
      this.show = true;
    },
    close() {
      this.show = false;
    },

    loadEvaluators() {
      this.loading = true;
      this.$api.evaluation.evaluatorsSearch({
        ...this.filters,
        types: ['colleague'],
        statuses: ['manage_request'],
        evaluatee_id: this.evaluateeId,
        evaluation_id: this.evaluationId,
        expand: ['user'].join(),
        [this.paginator.param]: this.paginator.page,
        [this.paginator.paramPerPage]: this.paginator.perPage,
      })
        .then(({data, paginator}) => {
          this.evaluators = data.evaluators;
          this.paginatorFill(paginator);
        })
        .finally(() => {
          this.loading = false;
        })
    },
    addSelectedRequests(all_confirm = 0, all_reject = 0) {
      this.show = false;

      let newEvaluatorIds = [];
      this.$refs.selectEvaluatorsTable.selection.forEach(evaluator => {
        newEvaluatorIds.push(evaluator.id);
      })

      if (newEvaluatorIds || all_confirm || all_reject) {
        this.$api.evaluation.requestsApprove({
          request_ids: newEvaluatorIds,
          evaluation_id: this.evaluationId,
          user_id: this.evaluateeId,
          all_confirm: all_confirm,
          all_reject: all_reject,
        })
          .then(data => {
            this.$notify.success({
              title: 'Сохранено',
              message: 'Коллеги успешно согласованы'
            });
          })
          .finally(()=>{
            this.loading = false;
            this.$emit('load-requests');
          })
      }
    },
    filtersChanged() {
      this.loadEvaluators();
    },
  }
}
</script>

<style>

</style>